import { DeepPartial } from 'ts-essentials';
import { IFunnelRaw, INodeRaw } from '../types/funnels';
import {
  autofixPlayerThumbnail,
  autofixPlayerTemplateConfig,
  autofixShareVideo,
  autofixPlayerChapters,
  autofixThumbnailItems,
  autofixTimelineItems,
  autofixPlayerSubtitles,
  autofixAttachedPlayerTemplates,
} from '@voomly/player/funnel-deps';

const autofixBuilderData = (
  builderData: DeepPartial<INodeRaw['builderData']> | undefined
): INodeRaw['builderData'] => {
  return {
    x: builderData?.x ?? Math.floor(Math.random() * 600),
    y: builderData?.y ?? Math.floor(Math.random() * 600),
    color: builderData?.color ?? Math.floor(Math.random() * 0xffffff),
  };
};

const autofixNodePlayer = (
  player: DeepPartial<INodeRaw>['player'] | undefined
): INodeRaw['player'] | undefined => {
  if (!player) {
    return;
  }

  return {
    ...player,
    chapters: autofixPlayerChapters(player?.chapters),
    subtitles: autofixPlayerSubtitles(player?.subtitles),
  };
};

const autofixFunnelNodes = (
  nodes: DeepPartial<INodeRaw[]> | undefined
): INodeRaw[] => {
  if (!nodes) {
    return [];
  }

  return nodes
    .map((node) => {
      if (!node) {
        return undefined;
      }
      return {
        id: node.id,
        builderData: autofixBuilderData(node.builderData),
        player: autofixNodePlayer(node.player),
        videoId: node.videoId,
        timelineItems: autofixTimelineItems(node.timelineItems),
      };
    })
    .filter((node): node is INodeRaw => Boolean(node));
};

export const autofixFunnel = (
  funnel: DeepPartial<IFunnelRaw> & { id: string }
): IFunnelRaw => {
  return {
    id: funnel.id,
    name: funnel.name ?? 'missing name',
    description: funnel.description,
    nodes: autofixFunnelNodes(funnel.nodes),
    startNodeId: funnel.startNodeId,
    playerConfig: autofixPlayerTemplateConfig(funnel.playerConfig),
    attachedPlayerTemplates: autofixAttachedPlayerTemplates(
      funnel.attachedPlayerTemplates
    ),
    thumbnail: autofixPlayerThumbnail(funnel.thumbnail),
    thumbnailItems: autofixThumbnailItems(funnel.thumbnailItems),
    shareVideo: autofixShareVideo(funnel.shareVideo),
    subtitles: autofixPlayerSubtitles(funnel.subtitles),
    updatedAt: funnel.updatedAt || '',
    createdAt: funnel.createdAt || '',
    deletedAt: funnel.deletedAt || '',
  };
};
